import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
// ... other firebase imports

const firebaseApp = initializeApp({
  apiKey: "AIzaSyCQGw1ao0ZEQGXbbEu4EMgWIYI-saIPgX0",
  authDomain: "suha-6471d.firebaseapp.com",
  projectId: "suha-6471d",
  storageBucket: "suha-6471d.firebasestorage.app",
  messagingSenderId: "1034399123912",
  appId: "1:1034399123912:web:bf985e57fd578ddf2fd8fd",
  measurementId: "G-MLTRSMXVW1"
})

// used for the firestore refs
const db = getFirestore(firebaseApp)

export default db;